<div class="page-title">
  <h1 *ngIf="!modoEdicao">Cadastrar pessoa</h1>
  <h1 *ngIf="modoEdicao">
    Visualizar pessoa {{nomeCompleto ? '|' : ''}} {{nomeCompleto}}
  </h1>
</div>

<section class="primeiro-container">
  <div class="container-toggles">

    <!-- 1. Cadastro -->
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 1}"
      (click)="telaExibida=1"
      *ngIf="podeExibirTela(1)"
    >
      Cadastro
    </button>

    <!-- 2. Triagem - Cindi -->
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 5}"
      (click)="telaExibida=5"
      *ngIf="podeExibirTela(5)"
    >
      Triagem - Cindi
    </button>

    <!-- 3. Hábitos alimentares (apenas Sobrepeso e Obesidade) -->
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 2}"
      (click)="telaExibida=2"
      *ngIf="podeExibirTela(2)"
    >
      Hábitos alimentares
    </button>

    <!-- 4. Plano alimentar (apenas Sobrepeso e Obesidade) -->
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 3 || telaExibida == 4}"
      (click)="telaExibida=3"
      *ngIf="podeExibirTela(3) || podeExibirTela(4)"
    >
      Plano alimentar
    </button>

    <!-- 5. Avaliação física -->
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 6}"
      (click)="telaExibida=6"
      *ngIf="podeExibirTela(6)"
    >
      Avaliação física
    </button>

    <!-- 6. Consultas e Exames -->
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 8}"
      (click)="telaExibida=8"
      *ngIf="podeExibirTela(8)"
    >
      Consultas e Exames
    </button>

    <!-- 7. Atividade Proposta (apenas Sobrepeso e Obesidade) -->
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 7}"
      (click)="telaExibida=7"
      *ngIf="podeExibirTela(7)"
    >
      Atividade Proposta
    </button>

  </div>

  <div *ngIf="podeExibirTela(3) && telaExibida == 3">
    <button class="plano-btn" (click)="abrirModalSelecionarCaracteristicas()">
      <mat-icon class="icon">add</mat-icon>
      Adicionar plano alimentar
    </button>
  </div>
</section>

@if (podeExibirTela(1) && telaExibida === 1) {
<app-cadastro-pessoa></app-cadastro-pessoa>
} @if (podeExibirTela(5) && telaExibida === 5) {
<app-triagem-cindi></app-triagem-cindi>
} @if (podeExibirTela(2) && telaExibida === 2) {
<app-habitos-alimentares-pessoa></app-habitos-alimentares-pessoa>
} @if (podeExibirTela(3) && telaExibida === 3) {
<app-plano-alimentar-pessoa
  [caracteristicas]="caracteristicasPlano"
  (planoSelecionado)="onPlanoSelecionado($event)"
></app-plano-alimentar-pessoa>
} @if (podeExibirTela(4) && telaExibida === 4) {
<app-plano-alimentar-refeicoes
  #planoCmp
  [planoSelecionado]="planoSelecionado"
  (planoSalvo)="onPlanoSalvo($event)"
></app-plano-alimentar-refeicoes>
} @if (podeExibirTela(6) && telaExibida === 6) {
<app-avaliacao-fisica></app-avaliacao-fisica>
} @if (podeExibirTela(8) && telaExibida === 8) {
<app-consultas-exames
  [linhaDeCuidadoId]="linhaDeCuidadoId"
  [linhaDeCuidadoNome]="linhaDeCuidadoNome"
></app-consultas-exames>
} @if (podeExibirTela(7) && telaExibida === 7) {
<app-atividade-proposta></app-atividade-proposta>
}